import { useSelector } from 'react-redux'
import page_img from '../../components/Navigation/icons/verifica.svg'
import { selectTranslations } from '../../services/i18n/i18nSlice'
import { useEffect, useRef, useState } from 'react'
import debounce from 'lodash.debounce'

import add_img from '../../assets/images/add.svg'
import results_img from '../../assets/images/exams/results.svg'
import ExamsList from './_components/ExamsList'
import ExamsTable from './_components/ExamsTable'

import '../UsersScreen/UserTable.css'
import './Exams.css'
import { Link } from 'react-router-dom'

import { useTour } from "@reactour/tour"
import { selectUserData, selectUserOnboarding } from "../../features/User/userSlice"
import { examsTourSteps } from "../../config/tour"

export default function ExamHomeScreen() {

    const [viewType, setViewType] = useState(localStorage.getItem("exams_view_type") || "box")
    const [statusFilter, setStatusFilter] = useState("all")
    const [searchInput, setSearchInput] = useState("")
    const [filter, setFilter] = useState({
        started: null,
        ended: null,
        state: "",
        search_pattern: "",
        limit: 25,
    })

    const t = useSelector(selectTranslations)

    const userOnboarding  = useSelector(selectUserOnboarding)
    const userData = useSelector(selectUserData)
    const { setIsOpen, setCurrentStep, setSteps, setMeta } = useTour()

    

    const changeStatusFilter = (e) => {
        switch(e.target.value){
            case 'all' : {
                setFilter({
                    ...filter,
                    started: null,
                    ended: null,
                    state: "",
                    limit: 20,
                })
            } break;
            case 'progress' : {
                setFilter({
                    ...filter,
                    started: true,
                    ended: false,
                    state: "ready",
                    limit: 20,
                })
            } break;
            case 'future' : {
                setFilter({
                    ...filter,
                    started: false,
                    ended: null,
                    state: "ready",
                    limit: 20,
                })
            } break;
            case 'past' : {
                setFilter({
                    ...filter,
                    started: null,
                    ended: true,
                    state: "ready",
                    limit: 20,
                })
            } break;
            case 'draft' : {
                setFilter({
                    ...filter,
                    started: null,
                    ended: null,
                    state: "draft",
                    limit: 20,
                })
            } break;
            case 'trash' : {
                setFilter({
                    ...filter,
                    started: null,
                    ended: null,
                    state: "deleted",
                    limit: 20,
                })
            } break;
            default: {
                setFilter({
                    ...filter,
                    started: null,
                    ended: null,
                    state: "",
                    limit: 20,
                })
            }
        }
        setStatusFilter(e.target.value)
    }

    const changeViewType = (e) => {
        localStorage.setItem("exams_view_type", e.target.value)
        setViewType(e.target.value)
    }

    const debouncedSetSearchPattern = useRef(
        debounce((value) => {
            setFilter((prevFilter) => ({ ...prevFilter, search_pattern: value }))
        }, 300)
    ).current

    const changeSearchInput = (e) => {
        setSearchInput(e.target.value)
        debouncedSetSearchPattern(e.target.value)
    }

    
    
    useEffect(()=>{
        setIsOpen(false)
        if( (
                !userOnboarding?.exams?.section_completed 
            ) && userOnboarding?.exams?.step_completed_count <= 2 && !userData?.is_super_admin){
            setTimeout(()=>{
                if(window.location.pathname?.includes("exams"))
                    setIsOpen(true)
            },1500)
            setSteps(examsTourSteps)
            setCurrentStep(userOnboarding?.exams?.step_completed_count)
            setMeta('exams')
        }
    },[])

    return (
        <section id="examsScreen">
            <div className='d-flex align-items-center justify-content-between'>
                <div className="page_title">
                    <img src={page_img} />
                    <h1>{t.exams.page_title}</h1>
                </div>
                <div className='d-flex'>
                    <Link to={'/exams/user_exams_search'}>
                        <button className='secondary'>
                            {t.exams.results}
                            <img className='ms-2' style={{maxWidth:'25px'}} src={results_img} />
                        </button>
                    </Link>
                    <Link to={'/exams/create'}>
                        <button className='ms-2'>
                            {t.exams.new_exam}
                            <img src={add_img} className='ms-2' />
                        </button>
                    </Link>
                </div>
            </div>
            <div>
                <div className='d-flex align-items-center justify-content-between mt-2 mb-3'>
                    <div className='d-flex exams-step-0'>
                        <div className='custom-radio-tab'>
                            <input type="radio" id="1" name="statusFilter" value="all" checked={statusFilter === "all"} onChange={changeStatusFilter}/>
                            <label htmlFor="1">
                                {t.exams.all}
                            </label>
                        </div>
                        <div className='custom-radio-tab ms-4'>
                            <input type="radio" id="2" name="statusFilter" value="progress" checked={statusFilter === "progress"} onChange={changeStatusFilter} />
                            <label htmlFor="2">
                                {t.exams.progress}
                            </label>
                        </div>
                        <div className='custom-radio-tab ms-4'>
                            <input type="radio" id="3" name="statusFilter" value="future" checked={statusFilter === "future"} onChange={changeStatusFilter}/>
                            <label htmlFor="3">
                                {t.exams.future}
                            </label>
                        </div>
                        <div className='custom-radio-tab ms-4'>
                            <input type="radio" id="4" name="statusFilter" value="past" checked={statusFilter === "past"} onChange={changeStatusFilter}/>
                            <label htmlFor="4">
                                {t.exams.past}
                            </label>
                        </div>
                        <div className='custom-radio-tab ms-4'>
                            <input type="radio" id="5" name="statusFilter" value="draft" checked={statusFilter === "draft"} onChange={changeStatusFilter}/>
                            <label htmlFor="5">
                                {t.exams.draft}
                            </label>
                        </div>
                        <div className='custom-radio-tab ms-4'>
                            <input type="radio" id="6" name="statusFilter" value="trash" checked={statusFilter === "trash"} onChange={changeStatusFilter}/>
                            <label htmlFor="6">
                                {t.exams.trash}
                            </label>
                        </div>
                    </div>
                    <div className='d-flex align-items-center'>
                        <div id='userSearchBar' className='me-3'>
                            <input type='text' value={searchInput} placeholder={t.exams.search_placeholder} onChange={changeSearchInput} />
                        </div>
                        <div className='d-flex view_type_toggle'>
                            <div className='custom-radio-tab'>
                                <input type="radio" id="view-box" name="viewType" value="box" checked={viewType === "box"} onChange={changeViewType}/>
                                <label htmlFor="view-box">
                                    {t.exams.grid_view}
                                </label>
                            </div>
                            <div className='custom-radio-tab ms-4'>
                                <input type="radio" id="view-table" name="viewType" value="table" checked={viewType === "table"} onChange={changeViewType}/>
                                <label htmlFor="view-table">
                                    {t.exams.table_view}
                                </label>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {viewType === "box" ? <ExamsList filter={filter} /> : <ExamsTable filter={filter} />}
        </section>
    )
}